import React from 'react';
import WorkflowLandingPage from '../components/WorkflowLandingPage';
import { JobType } from '../graphql/types';

/**
 * TitleSearchLandingPage - Wrapper component for the Title Search workflow.
 *
 * Renders the shared WorkflowLandingPage with JobType.TR to display and manage
 * Title Search (Title Report) jobs. The shared landing page lists the user's
 * TR jobs, shows each job's current step and status (Requirement 8.4), and
 * exposes the "Create Title Search Job" action.
 *
 * Requirements: 8.4
 */
const TitleSearchLandingPage: React.FC = () => {
  return <WorkflowLandingPage jobType={JobType.TR} />;
};

export default TitleSearchLandingPage;
